// extracted by mini-css-extract-plugin
export default {"payment":"ZF","title_row":"aG","border_bottom":"bG","promo_wrapper":"cG","payment_wrapper":"eG","label":"fG","card_row":"gG","cardcontain":"hG","card_input":"iG","card_error":"jG","card_label":"kG","lock":"lG","same_address":"mG","place_order_button":"nG","buttonwrap":"oG","hide_form":"pG","paypal_buttons":"qG","review_button":"rG","alt_payment":"sG"};
    if(module.hot) {
      // 1738836196943
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  